import React from 'react';

import {
  LegacyText,
  LegacyBox,
  Popover,
  InfoOutlinedIcon,
  Stack,
  Typography,
} from '@gogame/components';
import { NumberValueFormatter, DateValueFormatter } from '@gogame/intl-ts';

import { Row } from './components';

const BenchmarkTooltip = ({
  children,
  appRoasD7,
  roasD7Month1Back,
  roasD7Month2Back,
  businessEntities,
  justifyContent,
}) => {
  const businessPartnerLevel = businessEntities?.[0]?.level === 0;
  const businessEntitiesName = businessPartnerLevel
    ? 'Business Partner'
    : 'Affiliate(s)';

  return (
    <Popover
      hover={true}
      anchor={
        <Stack
          spacing={0.5}
          style={{ minWidth: 0 }}
          direction={'row'}
          gutter={4}
          alignItems={'center'}
          justifyContent={justifyContent}
        >
          <InfoOutlinedIcon sx={{ fontSize: 12 }} color={'action'} />
          <Typography variant={'inherit'} noWrap as={'span'}>
            {children}
          </Typography>
        </Stack>
      }
      anchorOrigin={{
        vertical: 'top',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      PaperProps={{
        style: {
          width: '215px',
          padding: '10px 16px',
        },
      }}
    >
      <Row>
        <LegacyBox width={'75%'} justifyContent={'flex-start'}>
          <LegacyText>App. benchmark</LegacyText>
        </LegacyBox>
        <LegacyBox width={'25%'} justifyContent={'flex-end'}>
          <LegacyText variant={'subtitle2'}>
            <NumberValueFormatter.Percent value={appRoasD7?.metricValue} />
          </LegacyText>
        </LegacyBox>
      </Row>
      <Row style={{ padding: '12px 0 4px' }}>
        <LegacyText size={'12px'} intensity={200}>
          {businessEntitiesName} benchmarks:
        </LegacyText>
      </Row>
      <Row>
        <LegacyBox width={'75%'} justifyContent={'flex-start'}>
          <LegacyText>
            <DateValueFormatter
              value={roasD7Month1Back?.period?.from}
              template={'MMMM'}
            />
          </LegacyText>
        </LegacyBox>
        <LegacyBox width={'25%'} justifyContent={'flex-end'}>
          <LegacyText>
            <NumberValueFormatter.Percent
              value={roasD7Month1Back?.metricValue}
            />
          </LegacyText>
        </LegacyBox>
      </Row>
      <Row>
        <LegacyBox width={'75%'} justifyContent={'flex-start'}>
          <LegacyText>
            <DateValueFormatter
              value={roasD7Month2Back?.period?.from}
              template={'MMMM'}
            />
          </LegacyText>
        </LegacyBox>
        <LegacyBox width={'25%'} justifyContent={'flex-end'}>
          <LegacyText>
            <NumberValueFormatter.Percent
              value={roasD7Month2Back?.metricValue}
            />
          </LegacyText>
        </LegacyBox>
      </Row>
    </Popover>
  );
};

export default BenchmarkTooltip;
